<script setup lang="ts">
const route = useRoute('games-library-id')
const router = useRouter()

definePage({
  meta: {
    action: 'read',
    subject: 'library',
  },
})

interface ScormPackage {
  title: string
  id: string
  iFrameSrc: string
}

const scormData = ref<ScormPackage>()

const { data } = await useApi<any>(`/scorm/${route.params.id}`)
if (data.value)
  scormData.value = data.value

function loadScript(src: string) {
  return new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`))
      return resolve()
    const el = document.createElement('script')

    el.src = src
    el.onload = () => resolve()
    el.onerror = () => reject(new Error(`Cannot load ${src}`))
    document.head.appendChild(el)
  })
}

onMounted(async () => {
  await loadScript('/js/scorm.min.js')
  await loadScript('/js/scorm-stub.min.js')

  const scorm = (window as any).pipwerks?.SCORM
  if (scorm && !scorm.connection.isActive) { // защита от повтора
    scorm.version = '1.2'
    scorm.init()
  }
})
</script>

<template>
  <div v-if="scormData">
    <!-- 👉 Header  -->
    <div class="d-flex justify-space-between align-center flex-wrap gap-y-4 mb-6">
      <div class="d-flex justify-center align-center flex-wrap">
        <VBtn
          color="secondary"
          variant="outlined"
          size="small"
          class="mr-4"
          @click="router.back()"
        >
          <VIcon icon="tabler-arrow-left" />
        </VBtn>
        <h4 class="text-h4 mb-1">
          {{ scormData.title }}
        </h4>
      </div>
    </div>
    <VRow>
      <VCol cols="12">
        <VCard>
          <VCardItem>
            <iframe
              id="sco"
              :src="scormData.iFrameSrc"
              style="width:100%;height:100vh;border:0"
            />
          </VCardItem>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>
